import { Injectable } from '@angular/core';

@Injectable()
export class GridService {

  constructor() { }

//This method will return HTML table with top 5 columns of the JSON Data
    CreateTableFromJSON(data: any, topFields  = 5) : any {
        // EXTRACT VALUE FOR HTML HEADER. 
    
        var col = [];
       // for (var i = 0; i < data.length; i++) {
        for (var i = 0; i < data.length; i++) {
          for (var key in data[i]) {
            if (col.indexOf(key) === -1 && col.length != topFields ) {              
              col.push(key);
            }
          }
        }
    
        // CREATE DYNAMIC TABLE.
        var table = document.createElement("table");
        table.className = "table";
    
        // CREATE HTML TABLE HEADER ROW USING THE EXTRACTED HEADERS ABOVE.
        var tr = table.insertRow(-1);                   // TABLE ROW.
        for (var i = 0; i < col.length; i++) {
          var th = document.createElement("th");      // TABLE HEADER.
          th.className = "th";
          th.innerHTML = col[i];
          tr.appendChild(th);
        }
    
        // ADD JSON DATA TO THE TABLE AS ROWS.
        for (var i = 0; i < data.length; i++) {
    
          tr = table.insertRow(-1);
    
          for (var j = 0; j < col.length; j++) {
            var tabCell = tr.insertCell(-1);
            tabCell.innerHTML = data[i][col[j]];
          }
        }

        return table;
    /* 
        var divContainer = document.getElementById("showData");
        divContainer.innerHTML = "";
        divContainer.appendChild(table); */
      }

}